/**
* DevExpress Dashboard (_chart-item-format-rule.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { chartItemFormatRuleSerializationsInfoBase } from './_chart-item-format-rule-base';
export let dataItemApplyToName = { propertyName: 'dataItemApplyToName', modelName: '@SeriesId', displayName: 'DashboardStringId.FormatRuleApplyTo', simpleFormAdapterItem: 'selectBoxEditor' };
export let applyToChartElement = { propertyName: 'applyToChartElement', modelName: '@ApplyToChartElement', displayName: 'DashboardStringId.FormatRuleApplyToChartElement', defaultVal: 'Point',
    simpleFormAdapterItem: 'buttonGroupEditor', values: {
        'Point': 'DashboardStringId.ChartElementPointCaption',
        'LineOrArea': 'DashboardStringId.ChartElementLineOrAreaCaption'
    }
};
export let chartItemFormatRuleSerializationsInfo = chartItemFormatRuleSerializationsInfoBase.concat([dataItemApplyToName, applyToChartElement]);
